import { render } from "./CaptainSelectBox.vue?vue&type=template&id=6a01e2db&scoped=true"
import script from "./CaptainSelectBox.vue?vue&type=script&lang=js"
export * from "./CaptainSelectBox.vue?vue&type=script&lang=js"

import "./CaptainSelectBox.vue?vue&type=style&index=0&id=6a01e2db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a01e2db"]])

export default __exports__